<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        </div>
        <div class="mb-2 mt-2 pt-3">
            <button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索" @search="searchEvent" :showGj="true">
                 <template #left>
            <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" v-auth="'add'+auth_val">添加</el-button>
        </template>
                <template #from>
                    <el-form inline ref="form" :model="from" label-width="100px">
                        <el-form-item label="客户账号" class="mb-0">
                            <el-input size="small" v-model="from.user_account" placeholder="搜索客户账号"></el-input>
                        </el-form-item>
                        <el-form-item label="创建时间" size="small" class="mb-0">
                            <el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
                             range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item class="mb-0">
                            <el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
                            <el-button size="small" @click="clearSearch">清空筛选条件</el-button>
                        </el-form-item>
                    </el-form>
                </template>
            </button-search>
        </div>
        

        <!-- 表格 -->
        <div class="mt-3 pt-2">
            <el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
                
                <el-table-column align="center" prop="finance_no" label="订单号"></el-table-column><el-table-column align="center" prop="user_account" label="客户账号"></el-table-column><el-table-column align="center" prop="pay_no" label="凭证"></el-table-column><el-table-column align="center" prop="msg" label="备注"></el-table-column><el-table-column align="center" prop="user_id" label="客户id"></el-table-column><el-table-column align="center" prop="type" label="类别"></el-table-column><el-table-column align="center" prop="income_type" label="收支类型"></el-table-column><el-table-column align="center" prop="trade_type" label="交易类型"></el-table-column><el-table-column align="center" prop="money" label="交易金额"></el-table-column><el-table-column align="center" prop="front_money" label="交易前金额"></el-table-column><el-table-column align="center" prop="after_money" label="交易后金额"></el-table-column>
                <el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="140" label="操作">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button @click="openModel(scope.row)"  v-auth="edit" size="mini" plain type="primary">修改</el-button>
                            <el-button @click="deleteItem(scope.row)" v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
        </div>


        <div style="height: 60px;"></div>
        <el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
            <!-- 底部 -->
            <div style="flex: 1;" class="px-2">
                <el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
                 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
                </el-pagination>
            </div>
        </el-footer>

        <el-dialog  :close-on-click-modal="false" 
            :title="editIndex > -1 ? '修改' : '添加'"
            :visible.sync="createModel" 
            top="5vh" 
            :width="layout.is_phone ? '90%' : '50%'">
            
            <div style="max-height: 65vh; overflow: auto;">
                <!-- 表單内容 -->
                <el-form :rules="rules" ref="form" :model="form" 
                    :label-width="layout.is_phone ? '80px' : '100px'" 
                    :label-position="layout.is_phone ? 'top' : 'left'">
                    
                </el-form>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="createModel = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>
<script>
    import { commondecrypt } from '@/main';
    import common from '@/common/mixins/common.js';
    import buttonSearch from '@/components/common/button-search.vue';
    
    export default {
        components: {
            buttonSearch
        },

        inject: ['layout', 'app'],
        mixins: [common],

        data() {
            return {
                createModel: false,
                editIndex: -1,
                //搜索數据
                from: {
                    user_account: '',
                    time: [],
                },

                model_title: 'Finance',
                auth_val: 'Finance',
                
                preUrl: "data/FinanceList", //列表
                addUrl: "data/addFinance", //修改
                delAllUrl: "data/delFinanceAll", //批量删除
                delUrl: "data/delFinance", //删除單条
                editStatusUrl: "data/editStatusFinance", //修改狀態

                tableData: [],

                form: {
                    id: 0,
                },

                prop: 'create_time',
                sort: 'descending',
                rule_list: [],
                total_list: [],
                
                rules: {
                    
                },
            
            }
        },
        methods: {
            handleClick(tab, event) {
                this.search = ''
                this.clearSearch()
                this.getList()
            },
            sortChange(column) {
                this.prop = column.prop
                this.sort = column.order
                this.getList()
            },
            handleAvatarSuccess(res, file) {
                this.form.img = URL.createObjectURL(file.raw);
                let en_data = commondecrypt(res.encryption)
                res.encryption = JSON.parse(en_data)
                if(res.encryption.code==1){
                    this.form.head = res.encryption.data.list.url
                }
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;
                return isJPG && isLt2M;
            },
            // 打开模态框
            openModel(e) {
                if(e){
                    this.form = {
                        
                    }
                    
                    this.editIndex = e.id
                }else{
                    this.form = {
                        
                    }
                    this.editIndex = -1
                }
                
                // 打开dialog
                this.createModel = true
            },

            //前往修改页面
            editItem(obj) {
                this.$router.push({
                    name: 'set_manager_rule',
                    query: {
                        item: obj
                    }
                })
            },
            getListResult(e) {
                this.tableData = e.list
                this.total_list = e.total_list
                this.check_img_list = e.list.map(item => {
                    return item.head
                })
            },
            // 清空篩選條件
            clearSearch() {
                this.from = {
                    user_account: '',
                    time: [],
                }

                this.$refs.buttonSearch.closeSuperSearch()
                this.search = ''
                this.getList()
            },
            // 選擇图片
            chooseImage() {
                this.app.chooseImage((res) => {
                    this.$set(this.form, 'headUrl', res[0].url);
                    this.form['headId'] = res[0].id
                    this.$set(this.form, 'headId', res[0].id);
                }, 1)
            }
        }
    }
</script>